import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Row from '../../../core/layout/Row';
import Button from '../../../core/form/Button';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import LocaleSelect from '../../../core/form/LocaleSelect';
import LocalFileInputButton from '../../../core/form/LocalFileInputButton';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';

const InstructionVideoUploadForm = (props) => {
  const handleUploadClick = (locale, fileExists, callback) => {
    if (fileExists) {
      ConfirmationDialogService.show(
        'Update Instruction Video',
        `Would you like to change the video file from locale ${locale}?`,
        () => callback()
      );
    } else {
      callback();
    }
  };

  return (
    <>
      <Row>
        <Column size={2}>
          <LocaleSelect
            required
            value={get(props.values, 'locale', '')}
            onChange={(value) => props.onChange('locale', value)}
            errorText={get(props.errors, 'locale', null)}
            disabled={props.submitting}
            resultFilter={(locale) => !props.selectedLocales.find((selectedLocale) => selectedLocale === locale.key)}
          />
        </Column>
        <Column size={4}>
          <TextInput
            required
            value={get(props.values, 'videoTitle')}
            label="Video title"
            disabled={props.submitting}
            onChange={(value) => props.onChange('videoTitle', value)}
            errorText={get(props.errors, 'videoTitle', null)}
          />
        </Column>
        <Column size={2}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <LocalFileInputButton
              isFormItem
              accept="video"
              formItemLabel="Upload the video"
              label="Select a file"
              required={!get(props.values, 'id', false)}
              value={get(props.values, 'video', null)}
              errorText={get(props.errors, 'video', null)}
              disabled={props.submitting}
              onClick={(callback) =>
                handleUploadClick(get(props.values, 'locale'), !!get(props.values, 'id'), callback)
              }
              onChange={(value) => {
                props.onChange('videoFileSize', value.size);
                props.onChange('video', value);
              }}
            />
            <div style={{ marginTop: '14px', marginLeft: '30px' }}>
              <Button
                label={`${get(props.values, 'id') ? 'Update locale video' : 'Add video to locale'}`}
                type="primary"
                onClick={props.onSubmit}
                disabled={props.submitting}
              />
            </div>
          </div>
        </Column>
      </Row>
    </>
  );
};

InstructionVideoUploadForm.propTypes = {
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  selectedLocales: PropTypes.array,
  submitting: PropTypes.bool,
};

InstructionVideoUploadForm.defaultProps = {
  onSubmit: () => false,
  onChange: () => false,
  values: {},
  errors: {},
  selectedLocales: [],
  submittinh: false,
};

export default InstructionVideoUploadForm;
